/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form-group[_ngcontent-%COMP%]{margin-bottom:15px}input[_ngcontent-%COMP%]{width:100%;padding:10px;font-size:14px;border:1px solid #ccc;border-radius:4px}"];
export { styles as styles };
